import { useQuery } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { CmSourceOfBookingResponseSchema } from "../response/CmSourceOfBookingResponse";

const API_VERSION = "v4";

// Interface untuk parameter filter
interface ParamsSourceOfBooking {
    property_id?: string;
    start_date?: string;
    end_date?: string;
}

// Interface untuk props yang diterima oleh hook
interface CmSourceOfBookingProps {
    filters: ParamsSourceOfBooking;
}

const useCmSourceOfBooking = (query: CmSourceOfBookingProps) => {
    return useQuery({
        // Kunci query yang unik untuk caching
        queryKey: [
            'cm-source-of-booking',
            ...Object.entries(query.filters ?? {})
                .map(([key, value]) => `${key}:${value}`),
        ],
        queryFn: async () => {
            try {
                const params = {
                    filter: Object.fromEntries(
                        Object.entries(query.filters ?? {}).filter(([_key, value]) => value)
                    ),
                };

                // Request ke endpoint baru
                const response = await privateApi.get(`/${API_VERSION}/channel-manager/source-of-booking`, { params });

                // Validasi respons menggunakan skema Zod
                const validationResult = CmSourceOfBookingResponseSchema.safeParse(response.data);
                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Invalid Source of Booking data format");
                }
                return validationResult.data;
            } catch (error) {
                console.error(`Failed to fetch Source of Booking`, error);
                throw error;
            }
        },
        retry: import.meta.env.VITE_MAX_RETRY,
        refetchOnWindowFocus: false,
    });
};

export default useCmSourceOfBooking;